import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { boardsService } from '../api/boards.service';
import { BOARD_KEYS } from './queryKeys';

export function useBoards(projectId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: BOARD_KEYS.byProject(orgId ?? '', projectId),
    queryFn: ({ signal }) => boardsService.getByProject(projectId, signal),
    staleTime: 300_000,
    enabled: !!orgId && !!projectId,
  });

  return {
    boards: data?.data ?? [],
    isLoading,
    isError,
  };
}
